import '../css/print.css'

const printPage = () => {
  window.print()
}

export { printPage }
